import type { ExtractResource } from "@prequel/import-react";
import { useListExtracts } from "@prequel/import-react";

import ResourceTable from "@/components/ResourceTable";
import Timestamp from "@/components/Timestamp";
import { useDatasetContext } from "@/pages/import/DatasetsPage/DatasetPage";

const COLUMNS = ["Submitted", "Started", "Ended", "Processed", "Inserted", "Errored"];

const ExtractsTable = () => {
  const { dataset } = useDatasetContext();
  const datasetId = dataset.id;

  const useExtracts = (params: { pageSize?: number }) => useListExtracts(datasetId, params);

  const rowMapper = (extract: ExtractResource) => ({
    id: extract.id,
    to: `/import/datasets/${datasetId}/extracts/${extract.id}`,
    cells: [
      { value: <Timestamp timestamp={extract.submitted_at} /> },
      { value: extract.started_at ? <Timestamp timestamp={extract.started_at} /> : "—" },
      { value: extract.ended_at ? <Timestamp timestamp={extract.ended_at} /> : "—" },
      { value: extract.records_processed?.toLocaleString() ?? "—" },
      { value: extract.records_new_inserted?.toLocaleString() ?? "—" },
      { value: extract.records_errored?.toLocaleString() ?? "—" },
    ],
  });

  return (
    <ResourceTable<ExtractResource>
      columns={COLUMNS}
      useQuery={useExtracts}
      rowMapper={rowMapper}
      emptyMessage="No extracts found for this dataset."
    />
  );
};

export default ExtractsTable;
